import { PracticePatient } from "@physiofit-digital/physiofit_types";
import * as Sentry from "@sentry/react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebaseConfig";

export type DeepPaths<T> = T extends object
  ? {
      [K in keyof T]-?: K extends string | number
        ?
            | `${K}`
            | `${K}${DeepPaths<T[K]> extends never ? "" : `.${DeepPaths<T[K]>}`}`
        : never;
    }[keyof T]
  : never;

export type PartialDeepPaths<T> = Partial<{ [K in DeepPaths<T>]: any }>;

// Returns false instead of throwing so callers can surface the failure to the
// patient. Sentry captures no console output in this app, so a bare
// console.error here would never reach monitoring (PF-5637).
export const editPracticePatient = async (
  id: string,
  newData: PartialDeepPaths<PracticePatient>,
): Promise<boolean> => {
  try {
    await updateDoc(doc(db, "practicePatients/" + id), newData);
    return true;
  } catch (error) {
    console.error("Error updating practice patient:", error);
    Sentry.captureException(error);
    return false;
  }
};
